import React, { useState } from 'react';
import './voice-casting.css';

// Interfaces de TypeScript
export interface VoiceSpecs {
  type: string;
  accent: string;
  skills?: string;
}

export interface ScriptLine {
  direction?: string;
  dialogue?: string;
}

export interface Character {
  id: number;
  name: string;
  role: string;
  age: string;
  culturalContext: string;
  profession: string;
  personality: string;
  voiceSpecs: VoiceSpecs;
  references: string[];
  scriptLines: ScriptLine[];
  image?: string;
}

const charactersData: Character[] = [
  // {
  //   id: 1,
  //   name: "NOVIO / HOMBRE 1",
  //   role: "Protagonista",
  //   age: "25 años",
  //   profession: "Estudiante de Ing. Aeroespacial",
  //   personality: "Extrovertido y ansioso. Perfeccionista, sobrepiensa mucho las cosas, se frustra rápido. Más cálido y relajado en confianza.",
  //   image: "/images/BOY.png",
  //   voiceSpecs: {
  //     type: "Medio-juvenil, variable",
  //     accent: "Neutro con influencia bogotana"
  //   },
  //   scriptLines: [
  //     {
  //       direction: "(Ansioso, acelerado)",
  //       dialogue: "¡No, espérate! Si no calibramos los parámetros de la trayectoria ahora mismo, el margen de error nos va a liquidar."
  //     },
  //     {
  //       direction: "(Pausa corta, buscando calma)",
  //       dialogue: "Sé que estoy sobrepensando, pero... confía en mí, ¿sí? Vamos a hacer que funcione."
  //     }
  //   ]
  // },
  {
  id: 2,
  name: "NOVIA / HIJA",
  role: "Protagonista",
  age: "23 años",
  profession: "Estudiante de Ing. Industrial",
  personality: "Generalmente tranquila y paciente, con un fuerte sentido de justicia. Es analítica y suele pensar antes de actuar, pero cuando la provocan o enfrenta una injusticia se muestra asertiva y confrontativa, sin groserías pero con firmeza. Con la familia es tierna y cercana. Con el novio es afectuosa y comprensiva, aunque también sabe motivarlo y hacerlo entrar en razón con determinación, impulsándolo a actuar sin demora.",
  culturalContext: "Mezcla cultural marcada: madre de ascendencia mexicana y santandereana, lo que hace que ocasionalmente se le escapen palabras o giros de esas regiones. Ha vivido casi toda su vida en Colombia, con infancia en Medellín por parte de su padre y una etapa en Bucaramanga, lo que le da un acento principalmente colombiano con matices regionales.",
  image: "/images/GIRL.png",
  voiceSpecs: {
    type: "Medio-agudo, juvenil, expresiva y brillante",
    accent: "Entre neutro y paisa, con influencia bogotana (se aceptan propuestas distintas pero acordes a la personalidad)",
    skills: "Canta, con tesitura algo potente, idealmente cercana a la cantante de 'Not Gonna Get Us' (t.A.T.u.), que combina brillo juvenil con fuerza y determinación"
  },
  references: [
    "Akane (Ranma ½)", "Toph Beifong (Avatar: La Leyenda de Aang)", "Kagome Higurashi (Inuyasha)",
  ],
  scriptLines: [
    {
      direction: "Ella está hablando con su novio a quien invitó a su casa para conocer a sus padres, pero el plan cambió (no llegaron ellos a tiempo) y es él quien va a esperarlos en la casa de su novia, mientras conversan él hace sus trabajos universitarios",
      dialogue: ""
    },
    {
      direction: "(Burlona, cantadita)",
      dialogue: "¡Jaja! ¡Te lo dijeee...!"
    },
    {
      direction: "Acaba de llegar con sus padres del aeropuerto, y se encuentran al novio riéndose solo, lo que genera muchas preguntas a sus padres",
      dialogue: ""
    },
    {
      direction: "(Conteniendo la risa, y explicando)",
      dialogue: "Tranquila ma, todos liberamos el estrés de alguna manera."
    },
    {
      direction: "(Con escepticismo irónico)",
      dialogue: "Maaa, no creo que papá sea del todo normal."
    }
  ]
},
  {
  id: 3,
  name: "MADRE",
  role: "Secundario",
  age: "48 años",
  profession: "Administradora de Empresas",
  personality: "Segura y de temperamento fuerte, con un perfil autoritario basado en el afecto. En el pasado tendía a dejarse llevar por las apariencias y por el 'qué dirán', ejerciendo un control estricto sobre su hija durante la etapa escolar. Con los años ha aprendido a flexibilizarse, a delegar y a confiar más, aunque en ocasiones resurgen esos comportamientos como expresión de preocupación. Con su esposo mantiene una relación de independencia práctica, pero con cierta dependencia emocional; él la motiva a fortalecer su autonomía para prepararla ante cualquier eventualidad. Es directa en su comunicación, pero procura suavizar y empatizar con la forma en que los demás perciben sus acciones, especialmente en su rol de jefa en el ámbito laboral.",
  culturalContext: "Madre de ascendencia mexicana y santandereana, con léxico y expresiones heredadas de esas raíces. Aunque su acento es principalmente neutro colombiano, conserva ocasionalmente giros mexicanos y santandereanos que refuerzan su carácter.",
  image: "/images/mom.png",
  voiceSpecs: {
    type: "Medio-aguda, firme y proyectada, con capacidad de transmitir autoridad sin perder calidez",
    accent: "Neutro colombiano con influencia santandereana y léxico mexicano ocasional (se aceptan propuestas distintas pero acordes a la personalidad)",
    skills: ""
  },
  references: 
  [
    "Molly Weasley (Harry Potter)", "Chicha (Las locuras del emperador)", "Milk (Dragon Ball, etapa escolar de Gohan)"
  ],
  scriptLines: [
      {
        direction: "(Preocupada)",
        dialogue: "Ay mija, no sé si preocuparme por él, o por ti..."
      },
      {
        direction: "La madre mira hacia arriba dando la razón a su hija tras un comentario",
        dialogue: ""
      },
      {
        direction: "(Con resignación ligera)",
        dialogue: "Sí, pero te pasas hija..."
      },
      {
        direction: "(Reflexiva, suspirando, casi entre dientes)",
        dialogue: "(suspiro) Bueno, eso sí... aunque es una rara primera impresión."
      }    
  ]
},
  {
  id: 4,
  name: "PADRE",
  role: "Secundario",
  age: "49 años",
  profession: "Mecánico Industrial",
  personality: "Sereno, serio y analítico, con baja expresividad emocional. Nunca se deja llevar por las apariencias, sino por las intenciones que percibe en los demás. Protector desde la lógica y la mediación, transmite confianza y orden. Amante de la tecnología, con un pasado de aficionado a los videojuegos que no pudo disfrutar plenamente debido a su situación económica y la necesidad de trabajar desde temprana edad. Conserva momentos de relajación y cierta faceta infantil, dejándose llevar por retos o situaciones lúdicas como si fueran desafíos entre amigos, similar a Hal de Malcolm in the Middle en su espontaneidad y ocasional pánico divertido. Con su hija es paciente y busca siempre lo mejor para ella, siendo celoso y protector. Con su esposa mantiene una relación tranquila, en la que suele ser la voz de la razón y la lógica, equilibrando su carácter fuerte. Aunque suele pensar antes de hablar, a veces puede ser imprudente por su franqueza, lo que genera comentarios directos que no siempre son bien recibidos.",
  culturalContext: "Colombiano con influencia bogotana en su acento, tono grave y pausado que refuerza su carácter sereno y lógico.",
  image: "/images/dad.png",
  voiceSpecs: {
    type: "Grave, pausado y contenido, con resonancia en pecho",
    accent: "Neutro con influencia bogotana (se aceptan propuestas distintas pero acordes a la personalidad)",
    skills: ""
  },
  references: ["Jor-El (Superman, versiones animadas)", "Maestro Splinter (Teenage Mutant Ninja Turtles)", "Hal (Malcolm in the Middle, en su faceta de retos)"],  
  scriptLines: [
    {
      direction: "Acaba de volver de un viaje y su hija les quiere presentar a su novio (en su propia casa), quien estaba al parecer riéndose solo a todo volumen",
      dialogue: ""
    },
    {
      direction: "(Reflexivamente)",
      dialogue: "Bueno, loco o no, habrá que evaluar al muchacho. Aún es temprano para concluir algo."
    },
    {
      direction: "La esposa y su hija lo miran con desaprobación luego de hacer un comentario que podría ser imprudente",
      dialogue: ""
    },
    {
      direction: "(Con indiferencia segura)",
      dialogue: "Qué bueno porque no tendré que repetirlo de nuevo."
    },
    {
      direction: "El padre cierra los ojos una vez más y suspira profundamente, abre los ojos y su postura cambia a una más comprensiva",
      dialogue: ""
    },
    {
      direction: "(Con nostalgia contenida)",
      dialogue: "(suspiro) Perdón... en todo caso es difícil soltar."
    }
  ]
}

  // {
  //   id: 5,
  //   name: "GATO",
  //   role: "Mascota / Personaje Especial",
  //   age: "N/A",
  //   profession: "Gato de la casa",
  //   personality: "Orgulloso, ostentoso y rencoroso. Necesidad constante de ser el centro de atención. Se percibe superior.",
  //   image: "/images/cat.png",
  //   voiceSpecs: {
  //     type: "Medio-agudo, altivo y teatral",
  //     accent: "Neutro con libertad de propuesta actoral / abierto"
  //   },
  //   scriptLines: [
  //     {
  //       direction: "Hombre 1 le ha minimizado, afectando su orgullo",
  //       dialogue: ""
  //     },
  //     {
  //       direction: "(orgulloso, despectivo/molesto)",
  //       dialogue: "¿Solo un gato...?"
  //     },
  //     {
  //       direction: "(El Gato recorre a Hombre 1 con la mirada de abajo hacia arriba, midiéndolo con absoluto desprecio. Sin romper esa trayectoria visual, extiende los dedos de su pata alzada y saca unas garras largas y afiladas)",
  //       dialogue: ""
  //     },
  //     {
  //       direction: "(Despectivo, Indignado)",
  //       dialogue: "Mocoso..."
  //     },
  //     {
  //       direction: "(CONT'D) (Grandilocuente y orgulloso)",
  //       dialogue: "¡No hace mucho, el mundo estaba a nuestros pies!"
  //     },
  //     {
  //       direction: "(Con rencor y actitud de villano)",
  //       dialogue: "Pronto reestableceremos nuestro IMPERIO... Y serán ustedes los humillados ¡como se merecen!"
  //     }
  //   ]
  // }
];

export const VoiceCasting: React.FC = () => {
  // Estado para el modal de Script
  const [selectedCharacter, setSelectedCharacter] = useState<Character | null>(null);

  // Estado para el modal de Ampliación de Imagen
  const [selectedImage, setSelectedImage] = useState<{ url: string; name: string } | null>(null);

  const handleOpenScript = (char: Character): void => {
    setSelectedCharacter(char);
  };

  const handleCloseScript = (): void => {
    setSelectedCharacter(null);
  };

  const handleOpenImage = (url: string, name: string): void => {
    setSelectedImage({ url, name });
  };

  const handleCloseImage = (): void => {
    setSelectedImage(null);
  };

  const handleSendDemo = (): void => {
    const email = "animation@stwarstudios.com";
    const subject = encodeURIComponent("Postulación Casting de Voz - [Tu Nombre]");
    const body = encodeURIComponent(
      "Hola equipo de StWar Studios,\n\nAdjunto mi prueba de audio para el casting de voz.\n\n" +
      "- Nombre completo:\n" +
      "- Personaje(s) al que me postulo:\n" +
      "- Teléfono / Contacto:\n\n" +
      "Quedo atento/a."
    );

    window.location.href = `mailto:${email}?subject=${subject}&body=${body}`;
  };

  return (
    <div className="casting-container">
      <header className="casting-header">
        <h1 className="casting-title">Casting de Voz para Animación Independiente</h1>
        <p className="casting-subtitle">
          Buscamos talentos de voz para dar vida a estos personajes. 
          Revisa las especificaciones a continuación, abre el <strong>Script de Audición</strong> y postúlate.
        </p>
      </header>

      <div className="characters-grid">
        {charactersData.map((char: Character) => (
          <div key={char.id} className="character-card">
            
            {/* Imagen del personaje con interacción de clic */}
            <div 
              className="character-image-wrapper clickable-image-wrapper"
              onClick={() => char.image && handleOpenImage(char.image, char.name)}
              title="Haz clic para ampliar la imagen"
            >
              {char.image ? (
                <>
                  <img 
                    src={char.image} 
                    alt={char.name} 
                    className="character-image"
                    onError={(e) => {
                      (e.target as HTMLElement).style.display = 'none';
                      const placeholder = (e.target as HTMLElement).nextElementSibling;
                      if (placeholder) placeholder.classList.remove('hidden');
                    }} 
                  />
                  <div className="image-zoom-overlay">
                    <span>🔍 Ampliar</span>
                  </div>
                </>
              ) : null}
              <div className={`image-placeholder ${char.image ? 'hidden' : ''}`}>
                <span>Espacio para imagen Canva</span>
                <small>({char.name})</small>
              </div>
            </div>

            <div className="character-content">
              <div className="character-header-info">
                <h2 className="character-name">{char.name}</h2>
                <span className="character-badge">{char.age}</span>
              </div>
              
              <span className="character-profession">{char.profession}</span>
              <p className="character-personality">{char.personality}</p>

              {/* Especificaciones Técnicas */}
              <div className="character-details">
                <h4 className="details-title">Especificaciones Vocales</h4>
                <p><strong>Voz:</strong> {char.voiceSpecs.type}</p>
                <p><strong>Acento / Influencia:</strong> {char.voiceSpecs.accent}</p>
                {char.voiceSpecs.skills && (
                  <p className="highlight-detail">
                    <strong>Habilidad extra:</strong> {char.voiceSpecs.skills}
                  </p>
                )}
              </div>

              {/* Botón para abrir el Pop-up del Script */}
              <button 
                className="script-modal-btn"
                onClick={() => handleOpenScript(char)}
              >
                Ver Script
              </button>

            </div>

          </div>
        ))}
      </div>

      {/* MODAL / POP-UP EMERGENTE DE SCRIPT ESTILO GUION */}
      {selectedCharacter && (
        <div className="script-modal-overlay" onClick={handleCloseScript}>
          <div className="script-modal-bubble screenplay-theme" onClick={(e) => e.stopPropagation()}>
            <button className="script-modal-close" onClick={handleCloseScript}>
              &times;
            </button>
            
            <div className="script-modal-header">
              <h3>SCRIPT DE AUDICIÓN</h3>
              <span className="modal-character-name">{selectedCharacter.name}</span>
            </div>

            <div className="script-modal-body screenplay-format">
              {selectedCharacter.scriptLines.map((line, idx) => (
                <div key={idx} className="screenplay-line-block">
                  {line.direction && (
                    <div className="screenplay-direction">{line.direction}</div>
                  )}
                  {line.dialogue && (
                    <div className="screenplay-dialogue">"{line.dialogue}"</div>
                  )}
                </div>
              ))}
            </div>

            <div className="script-modal-footer">
              <button className="modal-close-btn" onClick={handleCloseScript}>
                Cerrar Guion
              </button>
            </div>
          </div>
        </div>
      )}

      {/* MODAL PARA VER IMAGEN EN TAMAÑO COMPLETO */}
      {selectedImage && (
        <div className="image-modal-overlay" onClick={handleCloseImage}>
          <div className="image-modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="script-modal-close" onClick={handleCloseImage}>
              &times;
            </button>
            <img 
              src={selectedImage.url} 
              alt={selectedImage.name} 
              className="expanded-character-image" 
            />
            <span className="image-modal-caption">{selectedImage.name}</span>
          </div>
        </div>
      )}

      <section className="casting-cta">
        <h2>¿Te gustaría formar parte del proyecto?</h2>
        <p>
          Este es un proyecto INDIE, y serás tenido en cuenta para futuras animaciones/cortometrajes,
          como es algo que está en desarrollo tu opinion tambien es valiosa
          <br />
          Envíanos tu muestra de audio (MP3/WAV) libre de ruidos y con una calidad decente, adjúntala por correo indicando el personaje al que deseas postularte a:
          <br />
          <strong className="email-highlight">animation@stwarstudios.com</strong>
        </p>
        <button className="cta-button" onClick={handleSendDemo}>
          Enviar Demo por Correo
        </button>
      </section>
    </div>
  );
};

export default VoiceCasting;